import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/web/',
  routes: [
    {
      path: '/',
      component: () => import('@/page/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/login',  // 登录页面
      component: () => import('@/page/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/aitit',
      component: () => import('@/page/aiTit.vue'),
      meta: { title: 'AI标题' }
    },
    {
      path: '/aipic',
      component: () => import('@/page/aiPic.vue'),
      meta: { title: 'AI图片处理' }
    }, 
    {
      path: '/aipicedit',
      component: () => import('@/page/aiPicEdit.vue'),
      meta: { title: 'AI图片处理' }
    }, 
    {
      path: '/uselog',
      component: () => import('@/page/useLog.vue'),
      meta: { title: '金币消费记录' }
    },  
    {
      path: '/pay',
      component: () => import('@/page/pay.vue'),
      meta: { title: '在线支付' }
    },        
    {
      path: '/404',
      name:"404",
      component: () => import('@/page/404.vue'),
      meta: { title: '404' }
    }
  ]
});